import React from 'react'

const Text = props => {
	return (
		<div className="mb-5">
			<p>Как наш генератор utm-меток исправляет частые ошибки при формировании меток:</p>
			<ul>
				<li className="my-2">Заменяет пробелы и знак <b>&</b> в метках на <b>+</b>.</li>
				<li className="my-2">Автоматически заменяет мешающие аналитике символы <b>#</b>, <b>=</b> на дефис</li>
				<li className="my-2">Переводит все буквы в нижний регистр.</li>
				<li className="my-2">По умолчанию, для кодирования запрещенных в url-адресе символов, в том числе кириллицы, используются escape-последовательности. Но, вы можете выбрать транслитерацию кириллицы в латиницу. В этом случае генератор автоматически заменит запрещенные символы на дефис.</li>
				<li className="my-2">UTM-метка будет содержать в себе только один знак <b>?</b>.</li>
				<li className="my-2">Автоматически добавляет <b>http</b>, <b>https</b> и удаляет повторяющиеся значения</li>
				<li className="my-2">Проверяет указанную пользователем целевую ссылку на наличие грубых ошибок</li>
			</ul>
		</div>
	)
}

export default Text